import { mutationTypes } from '@/core/constants'
import { FiltroUtils } from '@/core/utils'

export default {
	[mutationTypes.ATA.SET_FILTRO_LISTAGEM](state, filtro) {
		state.filtro = filtro
	},

	[mutationTypes.ATA.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},

	[mutationTypes.ATA.LIMPAR_FILTRO_LISTAGEM](state) {
		FiltroUtils.limparFiltroAvancado(state.filtro)
	},

	[mutationTypes.ATA.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},

	[mutationTypes.ATA.SET_INFORMACOES_ATA](state, informacoesAta) {
		state.informacoesAta = informacoesAta
	},

	[mutationTypes.ATA.SET_NUMERO_ATA](state, numero) {
		state.informacoesAta.numero = numero
	},

	[mutationTypes.ATA.RESET_INFORMACOES_ATA](state) {
		state.informacoesAta = { processo: {} }
	},

	[mutationTypes.ATA.SET_BLOQUEIO_ATA](state, isBloqueado) {
		state.informacoesAta.isBloqueado = isBloqueado
	},
	[mutationTypes.ATA.SET_ENVIADA_PNCP](state, isEnviadaPncp) {
		state.informacoesAta.isEnviadaPncp = isEnviadaPncp
	},
	[mutationTypes.ATA.SET_URL_PNCP](state, urlPncp) {
		state.informacoesAta.urlPncp = urlPncp
	},
	[mutationTypes.ATA.SET_LISTA_CONTRATADOS](state, { itens }) {
		state.listaContratados = itens
	},
	[mutationTypes.ATA.SET_PAINEIS_INFORMACOES_ABERTOS](state, paineisAbertos) {
		state.paineisInformacoesAbertos = paineisAbertos
	},
	[mutationTypes.ATA.ADICIONAR_ABA](state, aba) {
		const existeAbaIgual = state.abas.filter((value) => value.titulo === aba.titulo).length > 0

		if (!existeAbaIgual) {
			state.abas.push(aba)
		}
	},
	[mutationTypes.ATA.SET_ID_ORGAO_ABA](state, idOrgao) {
		state.idOrgao.value = idOrgao
	},
	[mutationTypes.ATA.RESET_ID_ORGAO_ABA](state) {
		state.idOrgao.value = null
	},
}
